import React, { FunctionComponent } from 'react'
import { Circle, G, Path, Svg } from 'react-native-svg'

export const SideNavSearchIcon: FunctionComponent<SideNavSearchIconProps> = ({
  size = 32,
  fillColor,
  isFilled = false,
}) => {
  return (
    <Svg width={size} height={size} fill='none'>
      {isFilled ? (
        <G>
          <Path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M16.6798 19.2798C17.6915 18.6098 18.5756 17.7459 19.2848 16.7378C19.3819 16.8015 19.4749 16.8756 19.5622 16.9603L26.6782 23.8581C27.4292 24.586 27.4793 25.8139 26.7902 26.6006C26.1011 27.3874 24.9336 27.435 24.1826 26.7071L17.0666 19.8093C16.9051 19.6528 16.7761 19.4732 16.6798 19.2798Z'
            fill={fillColor}
          />
          <Circle cx='11.9889' cy='11.9687' r='8.32214' stroke={fillColor} stroke-width='2' />
        </G>
      ) : (
        <G>
          <Path
            d='M16.6798 19.2798L16.1277 18.446L15.3906 18.9341L15.7846 19.7255L16.6798 19.2798ZM19.2848 16.7378L19.8332 15.9016L19.0238 15.3707L18.4669 16.1624L19.2848 16.7378ZM19.5622 16.9603L18.8662 17.6783V17.6783L19.5622 16.9603ZM26.6782 23.8581L25.9822 24.5761L26.6782 23.8581ZM24.1826 26.7071L23.4866 27.4251L24.1826 26.7071ZM17.0666 19.8093L17.7626 19.0912L17.7626 19.0912L17.0666 19.8093ZM17.2319 20.1136C18.3499 19.3733 19.3233 18.421 20.1027 17.3131L18.4669 16.1624C17.8278 17.0709 17.0332 17.8464 16.1277 18.446L17.2319 20.1136ZM20.2582 16.2422C20.1257 16.1138 19.9834 16.0001 19.8332 15.9016L18.7364 17.574C18.7805 17.6029 18.824 17.6374 18.8662 17.6783L20.2582 16.2422ZM27.3742 23.1401L20.2582 16.2422L18.8662 17.6783L25.9822 24.5761L27.3742 23.1401ZM27.5424 27.2596C28.5825 26.0721 28.5077 24.2388 27.3742 23.1401L25.9822 24.5761C26.3507 24.9333 26.3761 25.5557 26.038 25.9417L27.5424 27.2596ZM23.4866 27.4251C24.6484 28.5513 26.4763 28.4766 27.5424 27.2596L26.038 25.9417C25.7258 26.2981 25.2188 26.3188 24.8787 25.9891L23.4866 27.4251ZM16.3706 20.5273L23.4866 27.4251L24.8787 25.9891L17.7626 19.0912L16.3706 20.5273ZM15.7846 19.7255C15.9299 20.0172 16.1254 20.2896 16.3706 20.5273L17.7626 19.0912C17.6849 19.0159 17.6223 18.9291 17.575 18.8341L15.7846 19.7255Z'
            fill={fillColor}
          />
          <Circle cx='11.9889' cy='11.9687' r='8.32214' stroke={fillColor} strokeWidth='2' />
        </G>
      )}
    </Svg>
  )
}

export type SideNavSearchIconProps = {
  size?: string | number
  fillColor?: string
  isFilled?: boolean
}
